// extracted by mini-css-extract-plugin
export default {"opas":"Hero_opas__VyL8q","heroTittle":"Hero_heroTittle__3bLyA","heroButton":"Hero_heroButton__LdzZF"};